import { CurrencyMntIcon } from './CurrencyMntIcon';

/**
 * author: Colton Wiscombe
 * id D0B20B31-ADBD-4F8A-9B72-52CC2FE4C3F4
 * name currency-mnt
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-mnt.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyMongolianTugrugIcon = CurrencyMntIcon;
export default CurrencyMongolianTugrugIcon